<template>
    <div>
        <notifications-emails
            :url="'notifications/form-submissions/' + emailableType + '/' + emailableId"
            :emailable-type="emailableType"
            :emailable-id="emailableId"
            :form-submission-notifications-title="formSubmissionNotificationsTitle"
            :form-submission-notifications-description="formSubmissionNotificationsDescription"
            :no-results-message="noResultsMessage"
        ></notifications-emails>
        <system-notifications-emails />
    </div>
</template>

<script>
import NotificationsEmails from "../components/account/notifications/NotificationsEmails";
import SystemNotificationsEmails from "../components/account/notifications/SystemNotificationsEmails.vue";

export default {
    name: 'account-notifications-page',
    props: {
        emailableType: {
            type: String,
            required: true,
        },
        emailableId: {
            type: Number,
            required: true,
        },
        type: {
            type: String,
            required: false,
        },
        formSubmissionNotificationsTitle: {
            type: String,
            required: true,
        },
        formSubmissionNotificationsDescription: {
            type: String,
            required: true,
        },
        noResultsMessage: {
            type: String,
            required: false,
        },
    },
    components: {
        NotificationsEmails,
        SystemNotificationsEmails
    },
};
</script>
